import routerOptions0 from "/usr/src/app/node_modules/.pnpm/nuxt@4.3.1_@parcel+watcher@2.5.6_@types+node@25.3.0_@vue+compiler-sfc@3.5.28_cac@6.7.14_46419a179021d583348e0bcdc70788e3/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}